import { render, staticRenderFns } from "./GenericCustomFields.vue?vue&type=template&id=5f4486cb&"
import script from "./GenericCustomFields.vue?vue&type=script&lang=ts&"
export * from "./GenericCustomFields.vue?vue&type=script&lang=ts&"
import style0 from "./GenericCustomFields.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports